import StatGrid from '@commons/stats'
import SectionHeading from '@commons/headings/section'
import Column from '@components/column'
import Tabs from '@commons/tabs'
import ActiveDoctors from './components/actives'
import RequestDoctors from './components/requests'
const AdminDoctorsPage = () => {
  const items: any = [
    {
      title: 'Total Doctor',
      value: '155',
      icon: 'doctor',
      bg: 'secondary50',
    },
    {
      title: 'Active Doctor',
      value: '23',
      icon: 'doctor',
      bg: 'green50',
    },
    {
      title: 'Inactive Doctor',
      value: '23',
      icon: 'doctor',
      bg: 'danger50',
    },
    {
      title: 'Total Doctor Payments',
      value: '23',
      icon: 'doctor',
      bg: 'yellow50',
    },
  ]

  const tabs = [
    {
      title: 'Doctor Vetification Request',
      key: 'request-doctors',
      Component: RequestDoctors,
    },
    {
      title: 'Active Doctor List',
      key: 'active-doctors',
      Component: ActiveDoctors,
    },
  ]

  return (
    <>
      <StatGrid items={items} />
      <Column styleColumn="margin-top:20px;margin-bottom:20px;">
        <SectionHeading title="Doctor Management" />
      </Column>
      <Tabs items={tabs} />
    </>
  )
}
export default AdminDoctorsPage
